import React, { useEffect, useRef, useState } from "react";
import hexToRgba from "hex-to-rgba";
import { Text } from "react-konva";
import helper_functions from "../../Config/helper_functions";

function DownloadText({
  textProperties,
  differenceFactor,
  canvasWidth,
  xPointsToAdd,
  yPointsToAdd,
  originalImageWidth,
  originalImageHeight,
  setImageCanvasExceededDispatch,
}) {
  const textRef = useRef();
  const [xCords, setXCords] = useState(0);
  const [yCords, setYCords] = useState(0);
  const [containerHight, setContainerHight] = useState(0);
  const [containerWidth, setContainerWidth] = useState(0);
  const [localScale, setLocalScale] = useState({ scaleX: 0, scaleY: 0 });

  useEffect(() => {
    if (textProperties.src) {
      textRef.current.cache();
      setContainerHight(textRef.current.height());
      setContainerWidth(textRef.current.width());
    }
  }, [textProperties]);

  useEffect(() => {
    let xDifference = textProperties.x - xPointsToAdd;
    let yDifference = textProperties.y - yPointsToAdd;
    setXCords(xDifference * differenceFactor);
    setYCords(yDifference * differenceFactor);
  }, []);

  useEffect(() => {
    if (
      textProperties.scaleX === 0 &&
      textProperties.scaleY === 0 &&
      containerWidth !== 0
    ) {
      const newScale = helper_functions.decryptToScaleAndSize(
        textProperties.width,
        canvasWidth,
        containerWidth
      );
      setLocalScale({ scaleX: newScale, scaleY: newScale });
      let scaleFactor = textRef.current.width();
      scaleFactor = canvasWidth / scaleFactor;
      textProperties.scaleX = newScale;
      textProperties.scaleY = newScale;
      textProperties.scaleFactor = scaleFactor * 2;
    } else {
      setLocalScale({
        scaleX: textProperties.scaleX,
        scaleY: textProperties.scaleY,
      });
    }
  }, [
    canvasWidth,
    containerWidth,
    textProperties.scaleX,
    textProperties.scaleY,
    textProperties.width,
  ]);

  useEffect(() => {
    if ((containerHight, containerWidth, localScale > 0)) {
      let x = parseInt(
          textProperties.x -
            getCenterPoint().x * (localScale * differenceFactor)
        ),
        y = parseInt(
          textProperties.y -
            getCenterPoint().y * (localScale * differenceFactor)
        );

      if (
        x + 2 < 0 ||
        x + containerWidth * (localScale * differenceFactor) >
          originalImageWidth + 0 ||
        y < 0 ||
        y + containerHight * (textProperties.scaleY * differenceFactor) >
          originalImageHeight + 0
      ) {
        setImageCanvasExceededDispatch(true);
      } else {
        setImageCanvasExceededDispatch(false);
      }
    }
  }, [containerHight, containerWidth, localScale]);
  const getCenterPoint = () => {
    let width;
    let height;
    if (textRef.current) width = textRef.current.textWidth / 2;

    if (textRef.current) height = textRef.current.textHeight / 2;
    const centerPoint = {
      x: width,
      y: height,
    };
    return centerPoint;
  };

  return (
    <>
      <Text
        ref={textRef}
        x={xCords}
        y={yCords}
        // fontSize={500}
        fontSize={Math.max(
          Math.min(
            Math.floor((canvasWidth * 13) / textProperties.src.length),
            500
          ),
          100
        )}
        fontFamily={textProperties.font}
        rotation={textProperties.deg}
        offsetX={getCenterPoint().x}
        offsetY={getCenterPoint().y}
        scaleX={textProperties.scaleX * differenceFactor}
        scaleY={textProperties.scaleY * differenceFactor}
        opacity={textProperties.opacity}
        shadowColor={hexToRgba(textProperties.shadowColor)}
        shadowEnabled={textProperties.enableShadowColor}
        shadowOffsetX={-20}
        shadowOffsetY={20}
        shadowBlur={50}
        wrap="char"
        fill={hexToRgba(textProperties.textColor)}
        text={textProperties.src}
        align={textProperties.textAlign}
        globalCompositeOperation="source-over"
      />
    </>
  );
}
export default DownloadText;
